var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"brand","dark":"","tile":""},on:{"click":_vm.clicked}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-plus")]),_vm._v(" "+_vm._s(_vm.$t("product.smartguide.add")))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }